"use strict";

exports.__esModule = true;
exports.space = void 0;

var _lodash = _interopRequireDefault(require("lodash.get"));

var _isNumber = _interopRequireDefault(require("lodash/isNumber"));

var _core = require("../core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getMargin(scale, path) {
  if (!(0, _isNumber["default"])(path)) {
    return (0, _lodash["default"])(scale, path, path);
  }

  var isNegative = path < 0;
  var absolute = Math.abs(path);
  var value = (0, _lodash["default"])(scale, absolute, absolute);

  if (!(0, _isNumber["default"])(value)) {
    return isNegative ? "-" + String(value) : value;
  }

  return value * (isNegative ? -1 : 1);
}

var config = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: getMargin
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: getMargin
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: getMargin
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: getMargin
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: getMargin
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: getMargin
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: getMargin
  },
  marginBlockStart: {
    property: 'marginBlockStart',
    scale: 'space',
    transform: getMargin
  },
  marginBlockEnd: {
    property: 'marginBlockEnd',
    scale: 'space',
    transform: getMargin
  },
  marginInline: {
    property: 'marginInline',
    scale: 'space',
    transform: getMargin
  },
  marginInlineStart: {
    property: 'marginInlineStart',
    scale: 'space',
    transform: getMargin
  },
  marginInlineEnd: {
    property: 'marginInlineEnd',
    scale: 'space',
    transform: getMargin
  },
  padding: {
    property: 'padding',
    scale: 'space'
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space'
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space'
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space'
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space'
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space'
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space'
  },
  paddingBlockStart: {
    property: 'paddingBlockStart',
    scale: 'space'
  },
  paddingBlockEnd: {
    property: 'paddingBlockEnd',
    scale: 'space'
  },
  paddingInline: {
    property: 'paddingInline',
    scale: 'space'
  },
  paddingInlineStart: {
    property: 'paddingInlineStart',
    scale: 'space'
  },
  paddingInlineEnd: {
    property: 'paddingInlineEnd',
    scale: 'space'
  }
};
config.m = config.margin;
config.mt = config.marginTop;
config.mr = config.marginRight;
config.mb = config.marginBottom;
config.ml = config.marginLeft;
config.mx = config.marginX;
config.my = config.marginY;
config.me = config.marginInlineEnd;
config.ms = config.marginInlineStart;
config.marginEnd = config.marginInlineEnd;
config.marginStart = config.marginInlineStart;
config.p = config.padding;
config.pt = config.paddingTop;
config.pb = config.paddingBottom;
config.pl = config.paddingLeft;
config.pr = config.paddingRight;
config.py = config.paddingY;
config.px = config.paddingX;
config.pe = config.paddingInlineEnd;
config.ps = config.paddingInlineStart;
config.paddingEnd = config.paddingInlineEnd;
config.paddingStart = config.paddingInlineStart;
var space = (0, _core.system)(config);
exports.space = space;